var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGithubIconinline = function SvgGithubIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    x: 5.5,
    y: 5.5,
    stroke: "#fff",
    strokeWidth: 3,
    rx: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4BEE",
    d: "M3.5 3.5h65v65h-65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2B4BEE",
    strokeWidth: 2,
    d: "M1 1h9v9H1zM62 1h9v9h-9zM1 62h9v9H1zM62 62h9v9h-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36 18c-9.945 0-18 8.259-18 18.455 0 8.167 5.153 15.064 12.308 17.51.9.161 1.237-.392 1.237-.877 0-.438-.023-1.892-.023-3.437-4.522.853-5.692-1.13-6.052-2.169-.203-.53-1.08-2.168-1.845-2.606-.63-.346-1.53-1.2-.023-1.223 1.418-.023 2.43 1.338 2.768 1.892 1.62 2.79 4.208 2.006 5.243 1.522.157-1.2.63-2.007 1.147-2.468-4.005-.462-8.19-2.053-8.19-9.113 0-2.007.697-3.668 1.845-4.96-.18-.46-.81-2.352.18-4.89 0 0 1.508-.485 4.95 1.892 1.44-.416 2.97-.623 4.5-.623s3.06.207 4.5.622c3.442-2.399 4.95-1.891 4.95-1.891.99 2.538.36 4.43.18 4.89 1.148 1.292 1.845 2.93 1.845 4.96 0 7.083-4.208 8.651-8.213 9.113.653.576 1.215 1.684 1.215 3.414 0 2.468-.022 4.452-.022 5.075 0 .485.337 1.061 1.237.877a18.07 18.07 0 0 0 8.879-6.733A18.8 18.8 0 0 0 54 36.455C54 26.26 45.945 18 36 18",
    clipRule: "evenodd"
  })));
};
export default SvgGithubIconinline;